import { Stack, Switch, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import { useChangeFieldForm } from '../../../hooks/useChangeFieldForm';
import { authService } from '../../../services/auth/AuthService';
import { ChangeBiometricAUthFormProps } from './types';

export const ChangeBiometricAuthForm: React.FC<
  ChangeBiometricAUthFormProps
> = ({ fieldLabel, cb, useBiometric }) => {
  useEffect(() => {
    if (useBiometric) setFieldValue('useBiometricAuth', useBiometric);
  }, [useBiometric]);

  const { values, submitForm, handleChange, setFieldValue } =
    useChangeFieldForm<'useBiometricAuth', boolean>(
      useBiometric,
      'useBiometricAuth',
      null,
      authService.updateUserBiometricStatus.bind(authService),
      'profilePage.updateEmailForm.emailIsAlreadyInUse',
      cb,
    );

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ gap: '15px' }}>
      <Typography color="common.white">{fieldLabel}</Typography>
      <Switch
        name="useBiometricAuth"
        checked={Boolean(values.useBiometricAuth)}
        onChange={(e) => {
          handleChange(e);
          submitForm();
        }}
        inputProps={{ 'aria-label': 'controlled' }}
        color="success"
      />
    </Stack>
  );
};
